export var ExpanderCssClass;
(function (ExpanderCssClass) {
    ExpanderCssClass["Base"] = "iress-expander";
    ExpanderCssClass["Activator"] = "iress-expander__activator";
    ExpanderCssClass["Container"] = "iress-expander__container";
    ExpanderCssClass["Inner"] = "iress-expander__container-inner";
    ExpanderCssClass["Open"] = "iress-expander--open";
})(ExpanderCssClass || (ExpanderCssClass = {}));
export var ExpanderMode;
(function (ExpanderMode) {
    ExpanderMode["Section"] = "section";
    ExpanderMode["Heading"] = "heading";
    ExpanderMode["Link"] = "link";
})(ExpanderMode || (ExpanderMode = {}));
export var ExpanderSlot;
(function (ExpanderSlot) {
    ExpanderSlot["Activator"] = "activator";
})(ExpanderSlot || (ExpanderSlot = {}));
//# sourceMappingURL=expander.types.js.map